import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center px-6 py-24">
      <h1 className="text-6xl font-display font-bold text-dark-primary mb-6">404</h1>
      <h2 className="text-2xl font-display text-dark-primary/80 mb-4">Página no encontrada</h2>
      <p className="text-text-muted mb-8 text-center max-w-md">
        Lo sentimos, la página que estás buscando no existe o ha sido movida.
      </p>
      <Link
        to="/"
        className="inline-flex items-center justify-center font-display text-xs uppercase tracking-luxury font-medium bg-dark-primary text-white hover:bg-black px-8 py-3 rounded-none transition-all duration-300"
      >
        Volver al inicio
      </Link>
    </div>
  );
};

export default NotFound;